var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', [_c('div', {
    staticClass: "dot-title el-color-primary-1"
  }, [_vm._v(" 上传文件 ")]), _c('div', {
    staticClass: "dot-tip el-color-gray-7"
  }, [_vm._v(" 如果您是初次使用，建议您 "), _vm.templateLink ? _c('a', {
    staticClass: "link el-color-primary-1",
    attrs: {
      "href": _vm.templateLink,
      "target": "_blank"
    }
  }, [_vm._v("下载导入模板")]) : _c('a', {
    staticClass: "link el-color-primary-1",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下载导入模板")]), _vm._v(" 进行查看 ")]), _c('div', {
    staticClass: "file-info"
  }, [_vm.showFile ? [_c('span', {
    staticClass: "upload-tip"
  }, [_vm._v(_vm._s(_vm.currentFile.name))]), _c('span', {
    staticClass: "upload-tip el-color-gray-7"
  }, [_vm._v("(" + _vm._s(_vm._f("fileSize")(_vm.currentFile.size)) + ")")])] : _vm._e(), _vm.showUploadBtn ? _c('el-upload', {
    ref: "upload",
    staticClass: "btn-upload",
    attrs: {
      "action": "",
      "accept": _vm.accept,
      "show-file-list": false,
      "auto-upload": false,
      "on-change": _vm.handleChange,
      "http-request": _vm.handleRequest
    }
  }, [_c('el-button', {
    staticClass: "btn-upload",
    attrs: {
      "type": _vm.btnType,
      "size": "small"
    }
  }, [_vm._v(" " + _vm._s(_vm.btnText) + " ")])], 1) : _vm._e(), _vm.isReady ? _c('el-button', {
    attrs: {
      "loading": _vm.uploading,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.confirmUpload
    }
  }, [_vm._v(" 确认上传 ")]) : _vm._e()], 2)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };